import * as React from 'react'

import IframeResizer from 'iframe-resizer-react'

import { CmsComponentSlot, CmsHeadTags } from '@grandvisionhq/bloomreach'
import { NextPage } from '@grandvisionhq/next'
import { useIntl } from '@grandvisionhq/state'
import { compose } from '@grandvisionhq/utils'

import { withCms, withLayout } from '../cms'

const BookAppointmentPage: NextPage = () => {
  const { getLabel } = useIntl()

  return (
    <>
      <CmsHeadTags>
        <link
          rel="preload"
          as="image"
          href={getLabel('appointments.selectionSteps.confirmationImageUrl')}
        />
      </CmsHeadTags>
      <CmsComponentSlot path="main/top-container" />
      <div className="book-appointment-wrapper">
        <h1>{getLabel('appointment.booking.page.title')}</h1>
        <IframeResizer
          id="appointment-booking-frame"
          log
          src="https://optica2000booking.azurewebsites.net/"
          frameBorder="0"
          style={{ width: '1px', minWidth: '100%' }}
        />
      </div>
      <CmsComponentSlot path="main/bottom-container" />
    </>
  )
}

export default compose(withCms(), withLayout())(BookAppointmentPage)
